import React, { useState, useEffect } from "react";
import { Table, Button, message, Upload } from "antd";
import { YHModal } from "@/components/YHModal";
import { useStockPoDetailModel } from "../purchaseDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { IImportParams, ISCMPoShiftImportDetail } from "../purchaseDetailsService";
import { YhBut } from "@/components/YhButton";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { ISelectOptions } from "@/types/ScmTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { Item, EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { importPropsConfig, messageConfig } from "@/utils/importFile";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { IPurchaseStock } from "@/views/sale/order/saleOrderTypes";
import { getRandomStr } from "@/utils/utils";
interface FilrResponse {
    retCode: number,
    retData: string,
    retMsg: string,
    success: boolean
}
interface File {
    uid?: string,
    name?: string,
    status?: string,
    response: FilrResponse,
    linkProps?: any
}
interface Upload {
    file: File,
    fileList: any,
    event: any
}
export const ShiftShelfModal = () => {
    const { shopAndOrg: { shopId }, warehouseList, setLoadingInfo } = useGlobalModel();
    const {
        shiftShelfModal: visible, setShiftShelfModal,
        selectedShelfRows, setSelectedShelfRows, shelftDownloadTpl,
        shiftShelfApi
    } = useStockPoDetailModel();
    const [shelfDs, setShelfDs] = useState<ISelectOptions[]>();  // 实时查询货位

    useEffect(() => {
        if (visible) {
            setSelectedShelfRows([]);
        }
    }, [visible])

    const onCancel = () => {
        setShiftShelfModal(false);
    };


    //货位根据仓库code查询
    const queryShelf = async (wsCode: string) => {
        const searchParams = {
            shopId,
            warehouseCode: wsCode,
            pageSize: -1,
            pageNum: 1,
        }
        let { retData } = await warehouseService.shelfAllPage(searchParams);
        setShelfDs(retData.map(item => ({
            id: item.id,
            label: item.code ?? "",
            value: item.code ?? ""
        })))
    }

    //仓库选择  (置空货位)
    const wsChange = (value: string, options: ISelectOptions, record: ISCMPoShiftImportDetail) => {
        if (options && options.id) {
            queryShelf(options.value as string)
        }
    }

    //货位触焦
    const shelfFocus = (record: Item) => {
        if (record["warehouseCode1"]) {
            queryShelf(record["warehouseCode1"] as string)
        } else {
            setShelfDs([]);
        }
    }


    const columnsSelect = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '原仓库',
            width: 160,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '原货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '原库存',
            width: 160,
            dataIndex: 'inventoryNum',
        }, {
            title: '仓库',
            width: 150,
            dataIndex: "warehouseCode1",
            // editable: true,
            editType: "select",
            options: transOptions(warehouseList), //过滤掉直发库
            onSelectChange: wsChange,
            render: (text: string) => warehouseList.find((item: any) => item.code === text)?.name
        }, {
            title: '货位',
            width: 150,
            dataIndex: 'shelfCode1',
            // editable: true,
            editType: "select",
            options: shelfDs,
            onSelectFocus: shelfFocus
        }, {
            title: '转移库存',
            width: 160,
            dataIndex: 'moveNum',
        }, {
            title: '转移类型',
            width: 160,
            dataIndex: 'moveType',
        }, {
            title: '操作',
            width: 80,
            align: "center",
            fixed: "right",
            className: "td-wrap",
            render: (text: any, record: ISCMPoShiftImportDetail) => <YhBut
                type="delete"
                txt="移除"
                click={() => {
                    const newData = selectedShelfRows.filter(item => item.key !== record.key);
                    setSelectedShelfRows(newData);
                }}
            />
        }
    ];

    const newSelectColumns = columnsSelect.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISCMPoShiftImportDetail, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IPurchaseStock) => {
        let dataSource = [...selectedShelfRows];
        const index = dataSource.findIndex((item) => row.key === item.key);

        //选中货位的话， 赋值货位code
        if (row.shelfCode1) {
            // debugger;
            row.shelfId1 = shelfDs?.find(item => item.value === row.shelfCode1)?.id;
        }
        //设置仓库名称
        if (row.warehouseCode1) {
            row.warehouseName1 = warehouseList.find((item: any) => item.code === row.warehouseCode1)?.name
        }
        //判断仓库变化时，  重置货位
        if (row.warehouseCode1 !== dataSource[index].warehouseCode1) {
            row.shelfCode1 = undefined
        }

        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setSelectedShelfRows([...dataSource]);
    }


    const upLoadCallback = (retData: IImportParams[]) => {
        if (!retData) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
            return message.warning("数据异常，请尝试重新导入")
        }
        // debugger;
        let newShelfRows: any[] = [...selectedShelfRows];
        let str: string = "";
        retData.forEach(item => {
            let isPut: boolean = item.moveType === "投放转移";
            if (!item.status) {
                str += `【${item.msg}】`
            }
            if (item.list && item.list.length) {
                for (let i = 0; i < item.list.length; i++) {
                    let goods = item.list[i];
                    // //投放转移模式，只匹配原仓库为投放仓库。
                    // if (isPut && goods.originalWarehouseCode !== "tf") continue;
                    // //正常转移模式，过滤掉原仓库为投放仓库的
                    // if (!isPut && goods.originalWarehouseCode === "tf") continue;
                    let findObj = newShelfRows.find(originGoods => originGoods.id === goods.id);
                    //过滤掉列表存在的  && 是直发仓库的 
                    if (!findObj) {
                        // if (!findObj && goods.originalWarehouseCode !== "999-zf") {
                        newShelfRows.push({
                            key: getRandomStr(),
                            ...goods,
                            inventoryNum: goods.originalInventoryNum ?? 0,
                            moveNum: goods.originalInventoryNum ?? 0,
                            warehouseCode: goods.originalWarehouseCode,// string,    //"3",
                            warehouseName: goods.originalWarehouseName,// string,    //"3",
                            shelfId: goods.originalShelfId,// string,    //"3",
                            shelfCode: goods.originalShelfCode,// string,    //"3",
                            warehouseCode1: goods.warehouseCode,    //转移仓库,
                            warehouseName1: goods.warehouseName,    //"3",
                            shelfId1: goods.shelfId,    //转移货位,
                            shelfCode1: goods.shelfCode,    //"3",
                            moveType: item.moveType
                        })
                    }
                }
            }
        })
        // console.log(newShelfRows)
        setLoadingInfo({ loadingVisible: false, txt: "" });
        if (!newShelfRows.length) {
            messageConfig("没有匹配到可正常转移的配件" + str, 3, "info");
            return;
        } else {
            messageConfig(str ? "以下配件导入异常：" + str : "导入成功", 20, "info");
        }
        setSelectedShelfRows(origin => [...origin, ...newShelfRows])
    }
    const action = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => shelftDownloadTpl()}
        >下载模板</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/stock/details/move/import/${shopId}`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }), {}, false)}>
            <Button className="mr-5" type="primary" shape="round">导入</Button>
        </Upload>
        {/* <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/scm2/purchase/po/launch/transfer/library/import/${shopId}`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }))}>
            <Button className="mr-5" type="primary" shape="round">投放导入</Button>
        </Upload> */}
    </>;

    return <YHModal
        visible={visible}
        onOk={() => {
            let filterPayData = selectedShelfRows.filter(item => (item.shelfCode1));
            if (filterPayData.length !== selectedShelfRows.length) {
                message.warning("请选择要转移的货位");
                return;
            }
            shiftShelfApi()
        }}
        onCancel={onCancel}
        title="采购明细-转移货位"
        width={'70%'}
        bodyHeight={600}
        showFooter={true}
    >
        <YhBox title="已选配件列表" rightChildren={action}>
            <Table
                bordered
                rowKey={record => record.key}
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<IPurchaseStock>}
                dataSource={selectedShelfRows}
                pagination={false}
                scroll={{ x: 'max-content', y: 450 }}
            />
        </YhBox>
    </YHModal>
}